
import { createReducer } from '@reduxjs/toolkit';
import {
    SET_PLAYLISTS_VIDEOS, SET_PLAYLISTS, SET_FEATURED_VIDEO, SET_CURRENT_LATEST_VIDEO, SET_CURRENT_VIDEO_TITLE, SET_NOT_FOUND,
} from '../actions/videosActions';


const initialState = {
    videos: {},
    playlists: [],
    notFound: false,
    featuredVideo: {
        videoId: false,
        videoImage: false,
        videoTitle: false,
        slug: false,
    },
    currentLatestVideo: {
        videoId: false,
        videoImage: false,
        videoTitle: false,
        slug: false,
    },
    currentVideoTitle: '',
};

const videosPage = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_PLAYLISTS_VIDEOS, (state, action) => {
            state.videos = action.videos;
        })
        .addCase(SET_PLAYLISTS, (state, action) => {
            state.playlists = action.playlists;
        })
        .addCase(SET_FEATURED_VIDEO, (state, action) => {
            state.featuredVideo = action.featuredVideo;
        })
        .addCase(SET_CURRENT_LATEST_VIDEO, (state, action) => {
            state.currentLatestVideo = action.currentLatestVideo;
        })
        .addCase(SET_CURRENT_VIDEO_TITLE, (state, action) => {
            state.currentVideoTitle = action.currentVideoTitle;
        })
        .addCase(SET_NOT_FOUND, (state, action) => {
            state.notFound = action.notFound;
        });
});

export default videosPage;
